/* CAMPY: Header transparency controller.
   If page has .campy-hero → adds .header-wrapper--transparent and manages .scrolled.
   No Liquid involvement — JS is the single source of truth. */
(function () {
  'use strict';
  const SCROLL_THRESHOLD = 50;

  function init() {
    const wrapper = document.querySelector('.header-wrapper');
    if (!wrapper) return;
    if (!document.querySelector('.campy-hero')) return;

    wrapper.classList.add('header-wrapper--transparent');
    let scrolled = false;

    function check() {
      const y = window.pageYOffset || document.documentElement.scrollTop;
      const shouldBeScrolled = y > SCROLL_THRESHOLD;
      if (shouldBeScrolled !== scrolled) {
        wrapper.classList.toggle('scrolled', shouldBeScrolled);
        scrolled = shouldBeScrolled;
      }
    }

    window.addEventListener('scroll', () => requestAnimationFrame(check), { passive: true });
    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
